import { getEmailType } from './getEmailType'

export default getEmailType
